<template>
    <div v-if="caseType > 0" class="details-wrap">
        <div class="details-content">
            <div v-if="$route.query.isDis == '1' || userId == 0" class="back-btn" @click="touchBack">返回</div>
            <img v-if="caseType == 1" class="top-bg" mode="aspectFill"
                 src="@/assets/images/project/v4/top_bg_1.png"></img>
            <img v-else-if="caseType == 2" class="top-bg" mode="aspectFill"
                 src="@/assets/images/project/v4/top_bg_2.png"></img>
            <img v-else-if="caseType == 3" class="top-bg" mode="aspectFill"
                 src="@/assets/images/project/v4/top_bg_3.png"></img>
            <img v-else-if="caseType == 5" class="top-bg" mode="aspectFill"
                 src="@/assets/images/project/v4/top_bg_5.png"></img>
            <img v-else class="top-bg" mode="aspectFill"
                 src="@/assets/images/project/v3/top_bg.png"></img>
            <div class="project-panel">
                <div class="status">{{ projectInfo.status }}</div>
                <div class="project-name">
                    {{ projectInfo.city || '--' }} ｜ {{
                        projectInfo.plot_name || projectInfo.community_name || '--'
                    }}项目案例
                </div>
                <div class="census">
                    <div class="share">
                        <img src="@/assets/images/project/v3/share_icon.png" alt="">
                        <span>{{ projectInfo.real_shares }}</span>
                    </div>
                    <div class="view">
                        <img src="@/assets/images/project/v3/look_blue.png" alt="">
                        <span>{{ projectInfo.real_views }}</span>
                    </div>
                </div>
                <div class="info">
                    <span v-if="projectInfo.house_area">{{ projectInfo.house_area }}</span>
                    <span v-if="projectInfo.house_area && projectInfo.house_type"> ｜ </span>
                    <span v-if="projectInfo.house_type">{{
                            projectInfo.house_type + projectInfo.house_type_room
                        }}</span>
                    <span v-if="projectInfo.house_cate && (projectInfo.house_area || projectInfo.house_type)">
                    ｜
                </span>
                    <span v-if="projectInfo.house_cate">{{ projectInfo.house_cate }}</span>
                    <span
                        v-if="projectInfo.type && (projectInfo.house_area || projectInfo.house_type || projectInfo.house_cate)">
                    ｜
                </span>
                    <span v-if="projectInfo.type">{{ projectInfo.type }}</span>
                </div>
            </div>
            <div v-if="isShowDiscuss" class="discuss-msg">
                “{{ discussMsg || '很满意史密斯这次的服务，采暖、空调效果也非常好' }}”

            </div>
            <div v-if="isShowDiscuss" class="discuss-panel">
                <div v-if="userInfo" class="user-box">
                    <div class="vague-img">
                        <img :src="userInfo.img" alt="">
                    </div>

                    <!-- <img v-if="userInfo.imgtype" src="@/assets/images/project/v3/daf_head1.png" alt="">-->
                    <!-- <img v-else src="@/assets/images/project/v3/daf_head2.png" alt="">-->
                    <div class="name">
                        {{ userInfo.name }}
                    </div>
                    <div class="time">
                        {{ projectInfo.city ? projectInfo.city + ' · ' : '' }}{{ userInfo.time }}
                    </div>
                </div>
                <!-- 施工 -->
                <template v-if="isUnfoldDiscuss">
                    <div v-if="discussInfo.sgInfo" class="discuss-box">
                        <div class="title">
                            <p>系统施工评价</p>
                            <vantRate v-model="discussInfo.sgInfo.score_num" readonly allow-half color="#ffd21e"
                                      void-icon="star"
                                      :size="16"
                                      void-color="#eee"></vantRate>
                            <p class="score">{{ discussInfo.sgInfo.score }}分</p>
                            <p class="time">{{ discussInfo.sgInfo.time }}</p>
                        </div>
                        <div class="content">
                            {{ discussInfo.sgInfo.content }}
                        </div>
                        <div class="img-box">
                            <template v-for="(item,index) in discussInfo.sgInfo.pic">
                                <div :class="['img-item',{'video-mask': item.type != 'image'}]">
                                    <img @click="toPreview(discussInfo.sgInfo.pic,index)" alt="'"
                                         :src="item.type == 'image' ? item.pic : item.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                </div>
                            </template>
                        </div>
                        <div v-if="discussInfo.sgInfo.voice" class="audio-box" @click="playAudio('sgInfo','audio_sg')">
                            <div class="icon">
                                <img :class="['audio-icon', {'audio-icon-act':discussInfo.sgInfo.isOpenVoice}]"
                                     src="@/assets/images/project/v3/audio_icon.png"
                                     alt="">
                            </div>
                            <div class="time">
                                {{ discussInfo.sgInfo.voice_time }}s
                            </div>
                            <div class="red-dit"></div>
                            <audio id="audio_sg" ref="audio_sg" :src="discussInfo.sgInfo.voice"
                                   @ended="onAudioEnd('sgInfo')"></audio>
                        </div>
                        <div v-if="(discussInfo.jgInfo || discussInfo.zpInfo)  && isShowUnfold" class="split"></div>
                    </div>
                </template>
                <!-- 竣工 -->
                <template v-if="discussInfo.zpInfo? isUnfoldDiscuss :true">
                    <div v-if="discussInfo.jgInfo" class="discuss-box">
                        <div class="title">
                            <p>竣工交付评价</p>
                            <vantRate v-model="discussInfo.jgInfo.score_num" readonly allow-half color="#ffd21e"
                                      void-icon="star"
                                      :size="16"
                                      void-color="#eee"></vantRate>
                            <p class="score">{{ discussInfo.jgInfo.score }}分</p>
                            <p class="time">{{ discussInfo.jgInfo.time }}</p>
                        </div>
                        <div class="content">
                            {{ discussInfo.jgInfo.content }}
                        </div>
                        <div class="img-box">
                            <template v-for="(item,index) in discussInfo.jgInfo.pic">
                                <div :class="['img-item',{'video-mask':item.type != 'image'}]">
                                    <img @click="toPreview(discussInfo.jgInfo.pic,index)" alt="'"
                                         :src="item.type == 'image' ? item.pic : item.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                                </div>
                            </template>
                        </div>
                        <div v-if="discussInfo.jgInfo.voice" class="audio-box" @click="playAudio('jgInfo','audio_jg')">
                            <div class="icon">
                                <img :class="['audio-icon', {'audio-icon-act':discussInfo.jgInfo.isOpenVoice}]"
                                     src="@/assets/images/project/v3/audio_icon.png" alt="">
                            </div>
                            <div class="time">
                                {{ discussInfo.jgInfo.voice_time }}s
                            </div>
                            <div class="red-dit"></div>
                            <audio id="audio_jg" ref="audio_jg" :src="discussInfo.jgInfo.voice"
                                   @ended="onAudioEnd('jgInfo')"></audio>
                        </div>
                        <div v-if="discussInfo.zpInfo && isShowUnfold" class="split"></div>
                    </div>
                </template>
                <!-- 追评 -->
                <div v-if="discussInfo.zpInfo" class="discuss-box">
                    <div class="title">
                        <p> {{ computTime(discussInfo.zpInfo.zhui_time) }}后追评 </p>
                        <p class="time">{{ discussInfo.zpInfo.time }}</p>
                    </div>
                    <div class="content">
                        {{ discussInfo.zpInfo.content }}
                    </div>
                    <div class="img-box">
                        <template v-for="(item,index) in discussInfo.zpInfo.pic">
                            <div :class="['img-item',{'video-mask': item.type != 'image'}]">
                                <img @click="toPreview(discussInfo.zpInfo.pic,index)" alt="'"
                                     :src="item.type == 'image' ? item.pic : item.pic+'?x-oss-process=video/snapshot,t_1000,m_fast'">
                            </div>
                        </template>
                    </div>
                </div>
                <!-- <div v-if="isShowUnfold" class="unfold" @click="toUnfold">
                    <p> {{ isUnfoldDiscuss ? '收起评价' : '展开评论' }}</p>
                    <div :class="['arrow-unfold',{'arrow':isUnfoldDiscuss}]"></div>
                </div>-->
            </div>
            <!-- 其他评价 -->
            <div v-if="!$route.query.isDis && caseType != 1 && nOtherDiscuss > 0" class="other-panel">
                <div class="top-box">
                    <div class="title" @click="touchVConsle">更多用户评价（{{ nOtherDiscuss || 0 }}）</div>
                    <div class="more" @click="toMoreDiscuss(0)">查看全部</div>
                </div>
                <div class="user-box">
                    <template v-for="item in otherInfo">
                        <div class="user-item" @click="toMoreDiscuss(item.id)">
                            <div class="vague-img">
                                <img :src="item.img" alt=""/>
                            </div>
                            <!-- <img v-if="item.imgtype" src="@/assets/images/project/v3/daf_head1.png" alt="">-->
                            <!-- <img v-else src="@/assets/images/project/v3/daf_head2.png" alt="">-->
                            <p>{{ item.name }}</p>
                        </div>
                    </template>
                    <div class="user-item" @click="toMoreDiscuss(0)">
                        <img src="@/assets/images/project/v3/more_icon.png" alt=""/>
                        <p>更多</p>
                    </div>
                </div>
            </div>

            <!-- 家装公司 -->
            <div class="company-panel"
                 v-if="caseType == 1 && (projectInfo.show_designer_company==1 || projectInfo.show_designer_name==1 || projectInfo.show_designer_discuss==1)">
                <img class="company-icon" src="@/assets/images/project/v4/company_icon.png"></img>
                <div class="company-tag">装饰设计合作方</div>
                <div class="company-content">
                    <div v-if="projectInfo.show_designer_company == 1" class="title">
                        {{ projectInfo.designer_company }}
                    </div>
                    <div v-if="projectInfo.show_designer_name == 1" class="item">
                        <img class="item-icon" src="@/assets/images/project/v4/company_item1.png"></img>
                        家装设计师：{{ projectInfo.designer_name }}
                    </div>
                    <template v-if="projectInfo.show_designer_discuss == 1">
                        <div class="item">
                            <img class="item-icon" src="@/assets/images/project/v4/company_item2.png"></img>
                            家装公司评价
                        </div>
                        <div class="item item2">
                            “{{ projectInfo.designer_discuss.content }}”
                        </div>
                        <div class="imgs"
                             v-if="projectInfo.designer_discuss.pic && projectInfo.designer_discuss.pic.length > 0">
                            <img v-for="(img,index) in projectInfo.designer_discuss.pic"
                                 @click="toPreview(projectInfo.designer_discuss.pic,index)"
                                 :src="img.pic" class="img"></img>
                        </div>
                    </template>
                </div>
            </div>
            <!-- 施工档案 -->
            <div v-if="isShowWork" class="info-panel">
                <div class="title">施工档案</div>
                <div v-if="projectInfo.design_url" class="work-box">
                    <div class="label">
                        <p>3D图纸</p>
                    </div>
                    <div class="more-content">
                        <!-- <div class="look-btn" @click="toLookWord(0)">点击查看</div>-->
                        <div class="look-btn" @click="nLookVrIndex = 9999">点击查看</div>
                    </div>
                    <div :class="['iframe-box iframe-box2',{'iframe-fixed':nLookVrIndex == 9999}]">
                        <iframe class="iframe" :src="projectInfo.design_url"></iframe>
                        <div class="mask" @click.stop="nLookVrIndex = 9999"></div>
                        <div v-if="nLookVrIndex != -1" class="quit" @click.stop="nLookVrIndex = -1">退出</div>
                    </div>
                </div>
                <template v-if="caseType == 1 && projectInfo.vr">
                    <template v-for="(item,index) in projectInfo.vr">
                        <div v-if="item.url" class="work-box">
                            <div class="label">
                                <p v-if="item.type == 11"> 五恒系统竣工 </p>
                                <p v-else> 五恒系统隐蔽施工 </p>
                                <span class="tag">VR</span>
                            </div>
                            <div :class="['iframe-box',{'iframe-fixed':nLookVrIndex == index}]">
                                <iframe class="iframe" :src="item.url"></iframe>
                                <div class="mask" @click.stop="nLookVrIndex = index"></div>
                                <div v-if="nLookVrIndex != -1" class="quit" @click.stop="nLookVrIndex = -1">退出</div>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-if="caseType != 1 &&projectInfo.completed == 1">
                    <template v-for="(item,index) in projectInfo.report">
                        <div v-if="item.attach && item.attach.length > 0" class="work-box">
                            <div class="label">
                                <p>{{ item.title }}</p>
                                <div class="more-box" @click="toLookWord(1,item.rule_report_id)">点击查看</div>
                            </div>
                            <div class="img-content">
                                <template v-for="(attach,index) in item.attach">
                                    <img :src="attach.image_url"
                                         alt="" @click="toPreview2(item.attach,index)">
                                </template>
                            </div>
                            <div class="item-content">
                                <div class="item-box">
                                    <template v-for="cate in item.cate_list">
                                        <div class="item">{{ cate }}</div>
                                    </template>
                                </div>
                                <img src="@/assets/images/project/v3/qualified.png" alt="">
                            </div>
                            <div v-if="item.report && item.report.length > (index + 1)" class="split"></div>
                        </div>
                    </template>
                </template>
                <template v-if="caseType != 1 && projectInfo.completed == 0">
                    <template v-for="(item,index) in projectInfo.item">
                        <div v-if="item.attach && item.attach.length > 0" class="work-box">
                            <div class="label">
                                <p>{{ item.title }}</p>
                                <div class="more-box" @click="toLookWord(1,item.id)">点击查看</div>
                            </div>
                            <div class="img-content">
                                <template v-for="(attach,index) in item.attach">
                                    <img
                                        :src="attach.image_url + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_200/quality,q_100'"
                                        alt="" @click="toPreview2(item.attach,index)"/>
                                </template>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <!-- 服务团队 -->
            <div v-if="projectInfo.servicer && projectInfo.servicer.length > 0" class="info-panel">
                <div class="title">服务团队</div>
                <div class="team-box">
                    <template v-for="item in projectInfo.servicer">
                        <div class="team-item">
                            <img
                                :src="item.icon"
                                alt="">
                            <div class="team-info">
                                <div class="info-box">
                                    <p>{{ item.name }}</p>
                                    <p v-if="item.job_number">工号:{{ item.job_number }}</p>
                                    <p v-if="item.num">项目经验：{{ item.num }}户</p>
                                </div>
                                <div class="position">
                                    {{ item.group_name }}:
                                    {{ item.desc }}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!-- 产品清单 -->
            <div v-if="projectInfo.goods_list && projectInfo.goods_list.length > 0" class="info-panel">
                <div class="title">产品清单</div>
                <div class="scroll-box">
                    <div class="goods-box">
                        <template v-for="item in projectInfo.goods_list">
                            <div class="goods-item">
                                <img :src="item.img" alt="">
                                <!--@click="toPreview2(projectInfo.goods_list,index)"-->
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!-- 了解更多 -->
            <div class="more-panel">
                <!-- <div class="title">了解更多</div>-->
                <div class="product arrow" @click="toMoreProduct">
                    <div class="product-link">
                        <img src="@/assets/images/project/v4/product_link.png" alt="">
                        同款产品
                    </div>
                    <!-- <img v-if="caseType == 1" class="product-pic" src="@/assets/images/project/v3/product_pic_vav.png"
                         alt="">
                    <img v-else class="product-pic" src="@/assets/images/project/v3/product_pic2.png" alt="">-->

                    <img v-if="caseType == 1" class="product-pic2"
                         src="https://pro-core.ali-cache.com/2021/aosmith/lottery/images2020/watersystem/image/project/v4/product_pic1.png"></img>
                    <img v-else-if="caseType == 2" class="product-pic2"
                         src="https://pro-core.ali-cache.com/2021/aosmith/lottery/images2020/watersystem/image/project/v4/product_pic2.png"></img>
                    <img v-else-if="caseType == 3" class="product-pic2"
                         src="https://pro-core.ali-cache.com/2021/aosmith/lottery/images2020/watersystem/image/project/v4/product_pic3.png"></img>
                    <img v-else-if="caseType == 5" class="product-pic2"
                         src="https://pro-core.ali-cache.com/2021/aosmith/lottery/images2020/watersystem/image/project/v4/product_pic5.png"></img>
                    <img v-else class="product-pic"
                         src="https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/product_pic2.png"></img>

                    <div class="text">
                        <!-- <p>A.O.史密斯 AI-LiNK</p>
                        <p>好风好水 智慧集成</p>-->
                        <!-- <p>A.O.史密斯</p>
                        <p v-if="caseType == 1">AI-LiNK高端智慧五恒集成系统</p>
                        <p v-else>AI-LiNK高端智慧集成系统</p>-->
                        <p>AI-LiNK</p>
                        <p v-if="caseType == 1">高端智慧五恒集成系统</p>
                        <p v-else-if="caseType == 2">高端智慧集成系统</p>
                        <p v-else-if="caseType == 3">高端智慧新风集成系统</p>
                        <p v-else-if="caseType == 5">高端智慧采暖系统</p>
                        <p v-else>高端智慧集成系统</p>
                    </div>

                </div>
                <!--  <div v-if="!$route.query.isDis" class="case arrow" @click="toMoreCase">
                    <img src="@/assets/images/project/v3/case_icon.png" alt="">
                    <div class="text">
                        更多案例
                    </div>
                </div>-->
            </div>
            <!-- <img v-if="caseType == 1" :class="['bottom-bg',{'bottom-bg2':mode == '1' && isZxy && userId > 0}]"
                 src="@/assets/images/project/v3/bottom_bg_vav2.jpg"></img>
            <img v-else :class="['bottom-bg',{'bottom-bg2':mode == '1' && isZxy && userId > 0}]"
                 src="@/assets/images/project/v3/bottom_bg3.jpg"></img>-->

            <div v-if="mode == '2'" class="staff-panel">
                <div class="staff-box">
                    <img class="head"
                         :src="projectInfo.qyuser.headimgurl || '@/assets/images/project/v3/staff_head.png'"
                         alt=""></img>
                    <div class="info-box">
                        <div class="name">{{ projectInfo.qyuser.nickname || '王小姐' }} 高级服务顾问</div>
                        <div class="position">联系服务访问，了解更多</div>
                    </div>
                    <img :src="projectInfo.qyuser.qrcode" class="qrcode"></img>
                </div>
            </div>

            <!-- 直销员进入详情页展示直销信息，分享详情页展示分享人信息 -->
            <!--  <div v-if="true" :class="['staff-panel',{'staff-panel2':mode == '1'}]">-->
            <!--  <div v-if="(mode == '1' && isZxy) || mode == '2'" :class="['staff-panel',{'staff-panel2':mode == '1'}]">-->
            <div class="bottom-logo">
                <img class="img"
                     src="https://pro-core.ali-cache.com/2021/aosmith/lottery/images2020/watersystem/image/project/v4/bottom_logo.png">
                </img>
            </div>
            <!-- 直销员进入详情页，才有分享 -->
            <!--        <template v-if="true">-->
            <template v-if="mode == '1' && isZxy && userId > 0">
                <div class="operate-panel">
                    <div class="btn" @click="toSTar">
                        <img v-if="projectInfo.isCollect" src="@/assets/images/project/v3/star.png" alt="">
                        <img v-else src="@/assets/images/project/v3/star_line.png" alt="">
                        收藏案例
                    </div>
                    <div class="btn btn-blue" @click="toShare">
                        <img src="@/assets/images/project/v3/share_pic.png" alt="">
                        分享案例
                    </div>
                </div>
            </template>
            <div :class="['bottom-color',{'bottom-color2':mode == '2'}]"></div>
        </div>
        <div v-if="isShowQrcode" class="qrcode-popup" @click="isShowQrcode = false">
            <div class="qrcode-box" @click.stop>
                <img class="qrcode" :src="qrCodeType == 1?qrProductCodeImg:qrShareCodeImg" alt="">
                <div class="text">
                    {{ qrCodeType == 1 ? '扫一扫，查看产品详情' : '扫一扫，获取分享页面' }}
                </div>
            </div>
        </div>

        <!-- <sharePanel :show="isShowSharePopup" :shareConfig="shareConfig" :isDiscuss="isShowDiscuss"
                    :projectId="projectInfo.pro_name" :images="projectInfo.images" :houseInfo="houseInfo"
                    @close="isShowSharePopup = false"></sharePanel>-->
        <media-preview :show="isShowPreview" :nIndex="nPreviewIndex" :arrUrl="arrPreview"
                       @close="closePreview"></media-preview>
        <!--        <img src="@/assets/images/antV2/back-icon02.png" v-if="mode == '1'" class="back-icon" @click="toBack" alt="">-->

    </div>
</template>

<script>
import {Rate} from 'vant';
import mediaPreview from '../components/preview/index.vue';
// import sharePanel from '../components/sharePanel/index.vue';
import {
    isComplete,
    getWordDelivery,
    getWordItem,
    getServiceItem,
    getSellerInfo,
    readNum,
    getPlanCaseInfo,
    getPlanCaseDiscuss,
    getPlanCaseDiscussList,
    checkPlanZxy,
    setPlanCollect,
    getPlanQrcode
} from "@/js/project/v3/index.js";

export default {
    name: "caseDetails",
    components: {
        vantRate: Rate,
        // sharePanel,
        mediaPreview
    },
    data() {
        return {
            mode: '1',//1-详情页，2-分享详情页
            userInfo: {},
            caseType: 0,
            projectInfo: {
                qyuser: {}
            },
            houseInfo: {},
            isShowDiscuss: false,
            isShowWork: false,
            discussMsg: '',
            discussInfo: {},
            isUnfoldDiscuss: true,
            isShowUnfold: true,
            //其他评论的用户信息
            nOtherDiscuss: 0,
            otherInfo: [],
            isShowPreview: false,
            nPreviewIndex: 0,
            arrPreview: [],
            isShowSharePopup: false,
            isShowQrcode: false,
            prevAudio: {
                key: '',
                el: null,
            },
            shareConfig: {},
            isZxy: false,
            tCensus: null,
            userId: '',
            nLookVrIndex: -1,
            qrProductCodeImg: '',
            qrShareCodeImg: '',
            qrCodeType: 0,//0-分享，1-产品
        }
    },
    mounted() {
        this.mode = this.$route.query.mode || '1';
        this.caseId = this.$route.query.id;
        this.userId = this.$route.query.user_id || 0;
        if (!this.caseId) {
            this.$toast({
                message: 'ID有误',
                duration: 800,
            });
        } else {
            this.pageInt()
        }
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.tCensus)
        this.tCensus = null;
        setTimeout(() => {
            next()
        }, 100)
    },
    methods: {
        touchBack() {
            this.$router.back()
        },
        randomNum() {
            return Math.round(Math.random() * 10) > 5
        },
        // 统计阅读量
        addReadNum(uuid, type, notice_type, log_id) {
            return new Promise(resolve => {
                let options = {
                    project_uuid: uuid,
                    type: type,
                    notice_type,
                    is_koubei: this.isShowDiscuss ? 1 : 0,
                    share_user_id: this.shareId
                }
                if (log_id) {
                    options.log_id = log_id
                }
                readNum(options, false).then(res => {
                    resolve(res.data.data.result)
                })
            })
        },
        pageInt() {
            this.$store.commit("loadSwitch", true);
            this.getCaseInfoFun().then(() => {
                Promise.all([this.getCaseDiscussFun(), this.getOtherDiscussFun(), this.checkZxyFun()]).then(() => {
                    // if (this.mode == '2') {
                    //     let shareId = this.shareId;
                    //     if (shareId != undefined && shareId != 'undefined') {
                    //         addEnterPrise({
                    //             from_id: shareId,
                    //             project_id: this.caseId,
                    //             sfrom: this.$route.query.ut_source,
                    //         })
                    //     }
                    //
                    //     // 进入首先统计进入页面的次数
                    //     this.addReadNum(this.projectInfo.pro_name, 'url', 'dis_pic').then(res => {
                    //         console.log(res, '121321')
                    //         this.tCensus = setInterval(() => {
                    //             console.log('统计数据')
                    //             // this.$toast('统计')
                    //             this.addReadNum(this.projectInfo.pro_name, 'url', 'dis_pic', res)
                    //         }, 5000)
                    //     })
                    // }

                    let obj = this.projectInfo;
                    let url = '';
                    console.log(obj.images)
                    if (obj.images.length > 0) {
                        url = encodeURI(obj.images[0].image_url)
                        // url = 'https://pro-mixed-tt.babycdn.com/aotest/uploads/project/2023/3/24/imgbiK6cG_1679637666669.png'
                    }
                    this.shareConfig = {
                        share_friend_title: obj.type + " | " + obj.city + obj.plot_name + "项目案例",
                        // share_friend_title: obj.plot_name,
                        share_friend_desc:
                            `${obj.house_area ? obj.house_area + ' ' : ''}` +
                            `${obj.house_type ? obj.house_type + ' ' : ''}` +
                            `${obj.house_type_room ? obj.house_type_room + ' ' : ''}` +
                            `${obj.house_cate ? obj.house_cate + ' ' : ''}`,
                        share_img_url: url,
                        share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}` +
                            `?mode=2&id=${this.$route.query.id}&ut_source=${this.$route.query.ut_source}` +
                            `&project_uuid=${this.projectInfo.pro_name}&shareId=${this.userId}` +
                            `&track_action=project_share_discuss&track_id=${this.$route.query.id}&track_uuid=${sessionStorage.getItem('page_uuid')}`
                    }
                    this.$store.commit("loadSwitch", false);

                    /*Promise.race([getWxSingleConfig(this.shareConfig), this.timeOutFun()]).then(() => {
                        this.$store.commit("loadSwitch", false);
                    }).catch((err) => {
                        /!*let msg = 'JSAPI授权失败：' + JSON.stringify(err || {})
                        window.alert(msg)*!/
                        this.$store.commit("loadSwitch", false);
                    })*/
                })
            })
        },
        timeOutFun() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    reject({
                        errMsg: '授权超时'
                    })
                }, 10000)
            })
        },
        checkZxyFun() {
            return new Promise((resolve, reject) => {
                if (this.userId > 0) {
                    checkPlanZxy({
                        user_id: this.userId,
                        // source: 'xcx', //只校验user_id
                    }).then((res) => {
                        this.isZxy = res.data.data.result;
                        resolve()
                    })
                } else {
                    resolve()
                }
            })
        },
        getCaseInfoFun() {
            return new Promise((resolve, reject) => {
                getPlanCaseInfo({
                    user_id: this.userId,
                    // source: 'xcx', //只校验user_id
                    share_user_id: this.shareId ? this.shareId : 0,
                    project_id: this.caseId
                }).then((res) => {
                    let data = res.data.data.result;
                    if (data.design_url) {
                        data.design_url = data.design_url + '&noinfo=true';
                        this.isShowWork = true;
                    }

                    data.isCollect = data.is_collect == 1 ? true : false;

                    this.houseInfo = {
                        city: data.city,
                        community_name: data.community_name,
                        created_at: data.created_at ? data.created_at.split(' ')[0] : '',
                        nickname: data.qyuser.nickname,
                        headimgurl: data.qyuser.headimgurl,
                        house_area: data.house_area,
                        house_cate: data.house_cate,
                        house_type: data.house_type,
                    };

                    if (data.designer_name) {
                        data.designer_name = `${data.designer_name.slice(0, 1) + '*'}${data.designer_name.length >= 3 ? data.designer_name.slice(-1) : ''}`;
                    }


                    console.log(data, 'data')
                    let caseType = 2;
                    // 1、智慧五恒系统
                    // 2、智慧集成系统
                    // 3、智慧新风系统
                    // 4、后装新风系统
                    // 5、采暖系统
                    switch (data.type) {
                        case '智慧五恒系统':
                            caseType = 1;
                            break
                        case '智慧集成系统':
                            caseType = 2;
                            break
                        case '智慧新风系统':
                            caseType = 3;
                            break
                        case '后装新风系统':
                            caseType = 4;
                            break
                        case '采暖系统':
                            caseType = 5;
                            break
                    }

                    if (caseType == 1) {
                        if (data.vr && data.vr.length > 0) {
                            data.vr.forEach((it) => {
                                if (it.url) {
                                    this.isShowWork = true;
                                }
                            })
                        }
                    } else {
                        if (data.completed == 1 && data.report && data.report.length > 0) { // 有交付报告
                            data.report.forEach((it) => {
                                it.title = it.title.replaceAll('监理报告', '')
                                if (it.attach && it.attach.length > 0) {
                                    this.isShowWork = true;
                                }
                            })
                        } else if (data.completed == 0 && data.item && data.item.length > 0) { // 无交付报告用工地直击数据：四大类
                            data.item.forEach((it) => {
                                it.attach = []
                                if (it.children && it.children.length > 0) {
                                    it.children.forEach((children) => {
                                        if (children.children && children.children.length > 0) {
                                            children.children.forEach((grandson) => {
                                                if (grandson.images && grandson.images.length > 0) {
                                                    this.isShowWork = true;
                                                }
                                                it.attach.push(...grandson.images)
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    }

                    this.caseType = caseType;
                    this.projectInfo = data;
                    resolve()
                })
            })
        },
        // 接口拆分调用V2版本
        /*getCaseInfoFun() {
            return new Promise((resolve, reject) => {
                getCaseInfoV2({
                    share_user_id: this.shareId ? this.shareId : 0,
                    project_id: this.caseId
                }).then(async (res) => {
                    let data = res.data.data.result;
                    if (data.design_url) {
                        this.isShowWork = true;
                    }
                    data.completed = await this.isCompleteFun(data.project_uuid);
                    if (data.completed == 1) { // 有交付报告
                        data.report = await this.getWordDeliveryFun(data.project_uuid);
                        this.isShowWork = true;
                        data.report.forEach((it) => {
                            it.title = it.title.replaceAll('监理报告', '')
                        })
                    } else if (data.completed == 0) { // 无交付报告用工地直击数据：四大类
                        data.item = await this.getWordItemFun();
                        this.isShowWork = true;
                        data.item.forEach((it) => {
                            it.attach = []
                            if (it.children && it.children.length > 0) {
                                it.children.forEach((children) => {
                                    if (children.children && children.children.length > 0) {
                                        children.children.forEach((grandson) => {
                                            it.attach.push(...grandson.images)
                                        })
                                    }
                                })
                            }
                        })
                    }

                    data.servicer = await this.getServiceItemFun();
                    data.qyuser = await this.getSellerInfoFun();

                    this.houseInfo = {
                        city: data.city,
                        community_name: data.community_name,
                        created_at: data.created_at ? data.created_at.split(' ')[0] : '',
                        nickname: data.qyuser.nickname,
                        headimgurl: data.qyuser.headimgurl,
                        house_area: data.house_area,
                        house_cate: data.house_cate,
                        house_type: data.house_type,
                    };
                    if(data.images){
                        data.images = JSON.parse(data.images)
                    }
                    console.log(data.images,'data.images')
                    this.projectInfo = data;
                    console.log(data, '数据数据');
                    resolve()
                })
            })
        },*/
        isCompleteFun(uuid) {
            return new Promise((resolve, reject) => {
                isComplete({
                    project_id: this.caseId,
                    project_uuid: uuid
                }).then((res) => {
                    let data = res.data.data.result;
                    resolve(data.complete || 0)
                })
            })
        },
        getWordDeliveryFun(uuid) {
            return new Promise((resolve, reject) => {
                getWordDelivery({
                    project_id: this.caseId,
                    project_uuid: uuid
                }).then((res) => {
                    let data = res.data.data.result;
                    resolve(data.report.report || [])
                })
            })
        },
        getWordItemFun() {
            return new Promise((resolve, reject) => {
                getWordItem({
                    project_id: this.caseId,
                }).then((res) => {
                    let data = res.data.data.result;
                    resolve(data.item || [])
                })
            })
        },
        getServiceItemFun() {
            return new Promise((resolve, reject) => {
                getServiceItem({
                    project_id: this.caseId,
                }).then((res) => {
                    let data = res.data.data.result;
                    resolve(data.servicer || [])
                })
            })
        },
        getSellerInfoFun() {
            return new Promise((resolve, reject) => {
                getSellerInfo({
                    share_user_id: this.shareId ? this.shareId : 0,
                }).then((res) => {
                    let data = res.data.data.result;
                    resolve(data.qyuser || [])
                })
            })
        },
        getCaseDiscussFun() {
            return new Promise((resolve, reject) => {
                getPlanCaseDiscuss({
                    user_id: this.userId,
                    // source: 'xcx', //只校验user_id
                    project_uuid: this.projectInfo.pro_name,
                }).then((res) => {
                    console.log(res)
                    let data = res.data.data.result;
                    if (data.lists && data.lists.length > 0) {
                        if (this.projectInfo.pro_name == data.lists[0].project_uuid) {
                            this.isShowDiscuss = true;
                            this.discussMsg = data.desc.poster_title;
                            let userInfo = {
                                // img: data.lists[0].headimgurl,
                                img: data.lists[0].headimgurl ? data.lists[0].headimgurl : this.randomHead(),
                                // imgtype: this.randomNum(),
                                name: data.lists[0].nickname ? `${data.lists[0].nickname.slice(0, 1) + '*'}${data.lists[0].nickname.length >= 3 ? data.lists[0].nickname.slice(-1) : ''}` : '***',
                                // time: data.lists[0].updated_at ? data.lists[0].updated_at.split(' ')[0].replaceAll('-', '.') : ''
                                time: data.lists[0].created_at ? data.lists[0].created_at.split(' ')[0].replaceAll('-', '.') : ''
                            }
                            this.userInfo = userInfo;
                            let discussList = data.lists;
                            let discussInfo = {
                                sgInfo: '',
                                jgInfo: '',
                                zpInfo: ''
                            };

                            discussList.forEach((it) => {
                                if (it.is_completed == 3) {
                                    discussInfo.sgInfo = {
                                        score: it.score,
                                        score_num: Number(it.score),
                                        content: it.content,
                                        pic: it.pic,
                                        voice_time: it.voice_time,
                                        voice: it.voice,
                                        time: it.created_at ? it.created_at.split(' ')[0].replaceAll('-', '.') : '',
                                        isOpenVoice: false //是否开始播放音频
                                    };
                                } else {
                                    discussInfo.jgInfo = {
                                        score: it.score,
                                        score_num: Number(it.score),
                                        content: it.content,
                                        pic: it.pic,
                                        voice_time: it.voice_time,
                                        voice: it.voice,
                                        time: it.created_at ? it.created_at.split(' ')[0].replaceAll('-', '.') : '',
                                        isOpenVoice: false //是否开始播放音频
                                    }
                                    if (it.content2 && it.zhui_time) {
                                        discussInfo.zpInfo = {
                                            content: it.content2,
                                            pic: it.pic_zhui,
                                            zhui_time: it.zhui_time,
                                            time: it.zhui_time ? it.zhui_time.split(' ')[0].replaceAll('-', '.') : '',
                                        }
                                    }
                                }
                            })
                            /*
                            * isShowUnfold
                            * sgInfo false
                            * sgInfo jgInfo true
                            * sgInfo jgInfo zpInfo true
                            * jgInfo false
                            * jgInfo zpInfo true
                            * */
                            if ((discussInfo.sgInfo && !discussInfo.jgInfo) || (discussInfo.jgInfo && !discussInfo.sgInfo && !discussInfo.zpInfo)) {
                                this.isUnfoldDiscuss = true;
                                // this.isShowUnfold = false;
                            } else {
                                this.isUnfoldDiscuss = true;
                                // this.isShowUnfold = true;
                            }
                            this.discussInfo = discussInfo;
                        } else {
                            this.isShowDiscuss = false;
                        }
                    } else {
                        this.isShowDiscuss = false;
                    }
                    /*if (this.mode == '1' && this.isShowDiscuss) {
                        //口碑阅读量
                        readNum({
                            project_uuid: this.projectInfo.pro_name,
                            type: 'koubei',
                            share_user_id: this.shareId
                        }).then()
                    }

                    //分享且有评论（bXcxShare 小程序里做了判断）
                    if ((this.mode == '2' && this.isShowDiscuss) || this.$route.query.bXcxShare == '1') {
                        //口碑分享量
                        shareNum({
                            project_uuid: this.projectInfo.pro_name,
                            sfrom: 'koubei',
                            from_id: this.shareId,
                            zhuanfa_type: 'koubei'
                        }).then()
                    }*/
                    resolve()
                })
            })
        },
        randomHead() {
            // return `https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/head-default${Math.floor(Math.random() * 4) + 1}.png`;
            return `https://pro-core.babycdn.com/2021/aosmith/lottery/images2020/watersystem/image/project/v3/head-default.png`;
        },
        getOtherDiscussFun() {
            return new Promise((resolve, reject) => {
                getPlanCaseDiscussList({
                    project_uuid: this.projectInfo.pro_name,
                    page: 0,
                    limit: 5,
                    type: 'all',
                    sort: 'id',
                    sort_type: 'desc',
                }).then((res) => {
                    let data = res.data.data.result;
                    let info = [];
                    if (data.total_num >= 1) {
                        let lists = data.lists;
                        if (lists.length > 5) {
                            lists = lists.slice(0, 5)
                        }
                        lists.forEach((it) => {
                            let item = it[0];
                            info.push({
                                project_id: item.project_id,
                                id: item.id,
                                // img: item.headimgurl,
                                img: item.headimgurl ? item.headimgurl : this.randomHead(),
                                // imgtype: this.randomNum(),
                                name: item.nickname ? `${item.nickname.slice(0, 1) + '*'}${item.nickname.length >= 3 ? item.nickname.slice(-1) : ''}` : '***',
                            })
                        })
                    }
                    this.nOtherDiscuss = data.total_num || 0;
                    this.otherInfo = info;
                    resolve()
                })
            })
        },
        //获取时间差
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replaceAll(/-/g, '/');
            let zhuiTime = new Date(endTime).getTime();
            let diffTime = (nowTime - zhuiTime) / 1000
            let timeData = ''
            if (diffTime < 0) {
                timeData = '1天'
            } else if (0 < diffTime && diffTime < 86400) {
                timeData = '1天'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '个月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }

            return timeData
        },
        closePreview() {
            this.isShowPreview = false;
        },
        toPreview(arr, i) {
            this.arrPreview = arr;
            this.nPreviewIndex = i;
            this.isShowPreview = true;
        },
        toPreview2(arr, i) {
            this.arrPreview = arr.map((it) => {
                return {
                    pic: it.image_url || it.img || it,
                    type: 'image'
                }
            });
            console.log(this.arrPreview)
            this.nPreviewIndex = i;
            this.isShowPreview = true;
        },
        toUnfold() {
            this.isUnfoldDiscuss = !this.isUnfoldDiscuss;
        },
        toSTar() {
            // this.$toast("此功能暂未开放");

            setPlanCollect({
                user_id: this.userId,
                // source: 'xcx', //只校验user_id
                xid: this.caseId,
                title: this.projectInfo.title
            }).then(() => {
                this.projectInfo.isCollect = !this.projectInfo.isCollect
            })

            // window.parent.postMessage({}, '*');

        },
        toShare() {
            this.qrCodeType = 0;
            if (this.qrShareCodeImg) {
                this.isShowQrcode = true;
            } else {
                getPlanQrcode({
                    page: 'project/v3/case/details/index',
                    param: JSON.stringify({
                        mode: 2,
                        isAuthPhone: false,
                        id: this.caseId,
                        ut_source: '',
                        isPlan: 1,
                        shareId: this.userId,
                        track_action: 'project_share_info',
                        track_id: this.caseId,
                        track_uuid: this.$storage.getStorage('pageuuid')
                    }),
                    is_hyaline: 1,
                    type: 1,
                }).then((res) => {
                    this.qrShareCodeImg = res.data.data.result.url;
                    this.isShowQrcode = true;
                })
            }
        },
        toMoreProduct() {
            if (this.$route.query.proSkip == '1') {
                let domainUrl = process.env.VUE_APP_FLAG == 'production' ? 'https://ai-link-gennc.iwxapi.com/' : 'https://aotestkit.iwxapi.com/'
                window.top.postMessage({type: 'product', caseType: this.caseType}, domainUrl);
                return
            }
            this.qrCodeType = 1;
            if (this.qrProductCodeImg) {
                this.isShowQrcode = true;
            } else {
                let param = {};

                if (this.caseType == 1) { //五恒
                    param = process.env.VUE_APP_FLAG == 'production' ? 'id=103&itemid=1583' : 'id=101&itemid=1836'
                } else if (this.caseType == 2) { //智慧集成
                    // param = process.env.VUE_APP_FLAG == 'production' ? 'id=73&itemid=930&name=1980' : 'type=package&id=136';
                    param = process.env.VUE_APP_FLAG == 'production' ? 'id=73&itemid=930&name=1980' : 'itemid=1505&materal=null&name=null&id=106';
                } else if (this.caseType == 3) { //新风
                    param = process.env.VUE_APP_FLAG == 'production' ? 'itemid=1467&materal=null&name=null&id=108' : 'itemid=1505&materal=null&name=null&id=106';
                } else if (this.caseType == 5) { //采暖
                    param = process.env.VUE_APP_FLAG == 'production' ? 'itemid=1021&materal=2483&name=2483&id=71' : 'itemid=1021&materal=2483&name=2483&id=71';
                } else {
                    param = process.env.VUE_APP_FLAG == 'production' ? 'id=73&itemid=930&name=1980' : 'type=package&id=136';
                }

                param += `v=${new Date().getTime()}`

                getPlanQrcode({
                    page: 'productc/pagesv2/goods_detail/index',
                    param: param,
                    is_hyaline: 1,
                    type: 1,
                }).then((res) => {
                    this.qrProductCodeImg = res.data.data.result.url;
                    this.isShowQrcode = true;
                })
            }
            //统计数据---产品详情阅读量
            /*if (this.mode == '2') {
                let param = process.env.VUE_APP_FLAG == 'production' ? `id=73&itemid=930&name=1980&project_uuid=${this.projectInfo.pro_name}&share_user_id=${this.shareId}` : `type=package&id=136&project_uuid=${this.projectInfo.pro_name}&share_user_id=${this.shareId}`;
                window.location.href = `${URLAPI.URL5}comm/scan/jumpurl?path=goods&params=${encodeURIComponent(param)}`;
            } else {
                let param = process.env.VUE_APP_FLAG == 'production' ? `id=73&itemid=930&name=1980` : `type=package&id=136`;
                window.location.href = `${URLAPI.URL5}comm/scan/jumpurl?path=goods&params=${encodeURIComponent(param)}`;
            }*/
        },
        toMoreCase() {
            //统计数据---更多案例
            if (this.mode == '2') {
                this.$router.replace({
                    path: `/project/plan/case/index?isShareInfo=true&share_id=${this.shareId}&project_uuid=${this.projectInfo.pro_name}&ut_source=${this.$route.query.ut_source}&user_id=${this.userId}`
                })
            } else {
                this.$router.replace({
                    path: `/project/plan/case/index?ut_source=${this.$route.query.ut_source}&user_id=${this.userId}`
                })
            }
        },
        toMoreDiscuss(id) {
            /*readNum({
                project_uuid: this.projectInfo.pro_name,
                type: 'pool_discuss',
                share_user_id: this.shareId
            }).then(res => {
                this.$router.push({
                    path: `/project/plan/discuss/index?id=${this.projectInfo.pro_name}&share_id=${this.shareId}&ut_source=${this.$route.query.ut_source}&mode=${this.mode}`
                })
            })*/

            if (id) {
                this.$router.push({
                    path: `/project/plan/discuss/index?id=${this.projectInfo.pro_name}&scrollId=${id}&case_id=${this.caseId}&share_id=${this.shareId || 0}&ut_source=${this.$route.query.ut_source || ''}&mode=${this.mode}&user_id=${this.userId}`
                })
            } else {
                this.$router.push({
                    path: `/project/plan/discuss/index?id=${this.projectInfo.pro_name}&case_id=${this.caseId}&share_id=${this.shareId || 0}&ut_source=${this.$route.query.ut_source || ''}&mode=${this.mode}&user_id=${this.userId}`
                })
            }
        },
        toLookWord(type, id) {
            if (type == 0) {
                window.location.href = this.projectInfo.design_url;
            } else {
                this.$router.push({
                    path: `/project/plan/word/index?id=${id}&mode=${this.projectInfo.completed}&projectId=${this.projectInfo.completed == 1 ? this.projectInfo.pro_name : this.projectInfo.id}&user_id=${this.userId}`
                })
            }
        },
        playAudio(key, ref) {
            let info = this.discussInfo[key];
            let el = this.$refs[ref];

            if (this.prevAudio.key && this.prevAudio.key != key) {
                this.prevAudio.el.pause();
                this.prevAudio.el.load();
                this.discussInfo[this.prevAudio.key].isOpenVoice = false;
            }

            this.prevAudio.el = el;
            this.prevAudio.key = key;

            if (info.isOpenVoice) {
                info.isOpenVoice = false;
                el.pause();
                el.load();
            } else {
                info.isOpenVoice = true;
                el.play()
            }
        },
        onAudioEnd(key) {
            let info = this.discussInfo[key];
            info.isOpenVoice = false;
        },
        toBack() {
            this.$router.back()
        },
        touchVConsle() {
            // vConsole.controlShow();
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./details.scss";
</style>
